import React, { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { Validator } from 'devextreme-react';
import { NumberBox } from 'devextreme-react';

type QuantityProps = {
  value: number;
  readOnly: boolean;
  onChange: (value: number) => void;
};

const Quantity: FC<QuantityProps> = ({ value, readOnly, onChange }) => {
  return (
    <AppFieldBox label="Объём (куб.)" labelTop>
      <NumberBox
        stylingMode="underlined"
        readOnly={readOnly}
        placeholder="Объём (куб.)"
        format="###0.##"
        value={value}
        onValueChanged={(e) => onChange(e.value)}
      >
        <Validator>
          <RequiredRule message="Заполните поле Объём" />
        </Validator>
      </NumberBox>
    </AppFieldBox>
  );
};

export default Quantity;
